import { render, staticRenderFns } from "./MarketplaceArticleDetail.vue?vue&type=template&id=32112f44&scoped=true&"
import script from "./MarketplaceArticleDetail.vue?vue&type=script&lang=js&"
export * from "./MarketplaceArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "../../less/complex.less?vue&type=style&index=0&id=32112f44&lang=less&scoped=true&"
import style1 from "./MarketplaceArticleDetail.vue?vue&type=style&index=1&id=32112f44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32112f44",
  null
  
)

export default component.exports